package com.eladfinish.bible.contest.screens.completeVerse.model

import androidx.compose.runtime.Immutable
import com.eladfinish.bible.contest.screens.search.model.VerseUiModel
import com.eladfinish.bible.contest.text.SpannableStringKMP
import kotlinx.collections.immutable.persistentListOf

@Immutable
data class VerseWithBlanks(
    val searchResult: VerseUiModel,
    val spannableStringKMP: SpannableStringKMP,
    val currentWordIndex: Int = 0,
) {
    val increasedIndex: VerseWithBlanks
        get() = copy(currentWordIndex = currentWordIndex + 1)

    companion object {
        val empty = VerseWithBlanks(
            searchResult = VerseUiModel(
                id = "",
                text = "",
                source = "",
                highlightedRanges = persistentListOf(),
                bookIndex = 0,
                chapterIndex = 0,
                verse = "",
            ),
            spannableStringKMP = SpannableStringKMP.empty,
        )
    }
}
